var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 74.28 48.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-2 {\n        fill: #003851;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -9631.88,
    y1: 11183.03,
    x2: -9631.88,
    y2: 11219.64,
    gradientTransform: "translate(-9586.75 11219.64) rotate(-180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6aa4a2",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#5da5a2",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#49a6a4",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#3aa7a5",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#31a8a5",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ea9a6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m37.94,26.07c5.38,0,9.74-4.36,9.74-9.74s-4.36-9.74-9.74-9.74-9.74,4.36-9.74,9.74,4.36,9.74,9.74,9.74Zm0-16.21c3.57,0,6.48,2.91,6.48,6.48s-2.91,6.48-6.48,6.48-6.48-2.91-6.48-6.48,2.91-6.48,6.48-6.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m42.88,29.55h-9.89c-8.68,0-15.75,7.06-15.75,15.75v1.95c0,.9.73,1.63,1.63,1.63s1.63-.73,1.63-1.63v-1.95c0-6.89,5.6-12.49,12.49-12.49h9.89c6.89,0,12.49,5.6,12.49,12.49v1.95c0,.9.73,1.63,1.63,1.63s1.63-.73,1.63-1.63v-1.95c0-8.68-7.06-15.75-15.75-15.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m14.03,26.08c4.31,0,7.8-3.49,7.8-7.8s-3.49-7.8-7.8-7.8-7.8,3.49-7.8,7.8,3.49,7.8,7.8,7.8Zm0-12.34c2.5,0,4.54,2.04,4.54,4.54s-2.04,4.54-4.54,4.54-4.54-2.04-4.54-4.54,2.04-4.54,4.54-4.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m15.97,29.55h-3.15c-7.07,0-12.82,5.75-12.82,12.82,0,.9.73,1.63,1.63,1.63s1.63-.73,1.63-1.63c0-5.27,4.29-9.56,9.56-9.56h3.15c.9,0,1.63-.73,1.63-1.63s-.73-1.63-1.63-1.63Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.52 0 74.28 .12 41.86 36.61 15.98 36.61 48.52 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.ef32fc911fc2a189f207595865aafe29.svg";
export { ForwardRef as ReactComponent };